import {FavoriteUserError} from './FavoriteUserError.js'

export class UnsubscribeFavoriteUserError extends FavoriteUserError {}
